// import { $req } from "../utils";
import request from '../utils/request'
export default {
	/*-------------------------------------------------------------设备start-----------------------------------------------------------  */
	// 配置数据接口
	getConfigData({ ...params }) {
		return request({
			method: 'GET',
			url: `/bpc/configData`,
			params: params
		})
	},
	//配置类数据初始化
	categorys({ ...params }) {
		return request({
			method: 'GET',
			url: `/pmp/data/init`,
			params: params
		})
	},
	//查询单位
	getMeasureUnitList({ ...params }) {
		return request({
			method: 'POST',
			url: `/mm/base/getMeasureUnitList`,
			data: params
		})
	},
	//研发-未立项项目预算查看
	getUnsetupQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/unsetup/query`,
			data: params
		})
	},
	//研发-未立项项目预算保存
	UnsetupQuerySave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/unsetup/save`,
			data: params
		})
	},
	//项目列表新
	getProjectListnew({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/project/list`,
			data: params
		})
	},
	//对照表
	comparelist(params) {
		return request({
			method: 'GET',
			url: `/bpc/research/setup/charge`,
			params: params
		})
	},


	//项目列表
	getProjectList({ ...params }) {
		return request({
			method: 'POST',
			url: `/pmp/project/forbpc/getList`,
			data: params
		})
	},

	//研发-已立项项目预算查看
	getSetupQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/setup/query`,
			data: params
		})
	},
	//研发-已立项项目预算暂存
	setupSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/setup/save`,
			data: params
		})
	},
	//研发-已立项项目预算详情
	setupDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/research/setup/detail`,
			data: params
		})
	},
	//研发-已立项项目删除
	delete({ ...params }) {
		console.log('hhhhhhh')
		return request({
			method: 'POST',
			url: `/bpc/research/setup/delete`,
			data: params
		})
	},
	//通用项目-查看
	queryProBudgetList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/queryProBudgetList`,
			data: params
		})
	},
	//通用项目-详情
	queryProBudgetDetails({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/queryProBudgetDetails`,
			data: params
		})
	},
	//通用项目-保存
	saveProBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/saveProBudget`,
			data: params
		})
	},
	//通用项目-删除
	delProBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/common/project/delProBudget`,
			data: params
		})
	},
	//税金预算-查询
	queryTaxBudget({ ...params }) {
		return request({
			method: 'POST',
			// url: `queryTaxBudget`,
			url: `/bpc/tax/queryTaxBudget`,
			data: params
		})
	},
	//税金预算-保存
	saveTaxBudget({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/tax/saveTaxBudget`,
			data: params
		})
	},
	//市场项目--------------------------------------------
	marketQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/market/query`,
			data: params
		})
	},
	marketDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/market/delete`,
			data: params
		})
	},
	marketSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/market/save`,
			data: params
		})
	},
	marketDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/market/detail`,
			data: params
		})
	},
	getCategoryList({ ...params }) {
		return request({
			method: 'POST',
			url: `/mm/base/getCategoryList`,
			data: params
		})
	},
	//医学研究项目----------------------------------------
	medicalResearch({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/medicalResearch/query`,
			data: params
		})
	},
	medicalSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/medicalResearch/save`,
			data: params
		})
	},
	medicalDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/medicalResearch/delete`,
			data: params
		})
	},
	medicalDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/medicalResearch/detail`,
			data: params
		})
	},
	//其他项目-----------------------------------------------
	otherDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/other/delete`,
			data: params
		})
	},
	otherSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/other/save`,
			data: params
		})
	},
	otherQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/other/query`,
			data: params
		})
	},
	otherDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/other/detail`,
			data: params
		})
	},
	//政府拨款项目--------------------------------------------

	governmentGrantDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/governmentGrant/delete`,
			data: params
		})
	},
	governmentGrantSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/governmentGrant/save`,
			data: params
		})
	},
	governmentGrantQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/governmentGrant/query`,
			data: params
		})
	},	
	//BD项目--------------------------------------------

	BdDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/bd/delete`,
			data: params
		})
	},
	BdSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/bd/save`,
			data: params
		})
	},
	BdQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/bd/query`,
			data: params
		})
	},
	BdDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/bd/detail`,
			data: params
		})
	},
	getBdProjectList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/bd/project/queryBdProjectList`,
			data: params
		})
	},
	//战略合作项目--------------------------------------------

	StrategyDelete({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/strategy/delete`,
			data: params
		})
	},
	StrategySave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/strategy/save`,
			data: params
		})
	},
	StrategyQuery({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/strategy/query`,
			data: params
		})
	},
	StrategyDetail({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/strategy/detail`,
			data: params
		})
	},
	//中试需求-------------------------------------------------
	produceTestList({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produceTest/queryList`,
			data: params
		})
	},
	produceTestSave({ ...params }) {
		return request({
			method: 'POST',
			url: `/bpc/produceTest/save`,
			data: params
		})
	},

}